import type { ApplicationEnum } from "~/@types/enums";
import type { DockShellModel } from "~/components/dock/dockShellModel";
import type { FusionMenuConfig } from "~/components/dock/FusionMenu";
import type { ModuleColorKey } from "~/themes/moduleColors";

import createDockShellModel, { type DockPage } from "~/components/dock/dockShellModel";
import { modulePalettes } from "~/themes/moduleColors";

export interface MinimalRailItem {
	icon: string;
	id: string;
	path: string;
	title: string;
}

export interface MinimalRailShell {
	config: FusionMenuConfig;
	model: DockShellModel;
}

const COMPANY_LOGO = "/logos/company.svg";

const resolveThemeColor = (module: ApplicationEnum): string =>
	modulePalettes[module.toUpperCase() as ModuleColorKey]?.primary ?? modulePalettes.WORKSUITE.primary;

const buildMinimalRailShell = (
	module: ApplicationEnum,
	items: MinimalRailItem[],
	brandIcon: string
): MinimalRailShell => {
	const pages: DockPage[] = items.map((item) => ({
		element: <></>,
		id: item.id,
		path: item.path,
		title: item.title
	}));

	const config: FusionMenuConfig = {
		hideLayouts: true,
		icon: brandIcon,
		logo: COMPANY_LOGO,
		module,
		sections: items.map((item) => ({
			groups: [{ items: [{ icon: item.icon, pageId: item.id }] }],
			icon: item.icon,
			id: item.id,
			label: item.title
		})),
		themeColor: resolveThemeColor(module)
	};

	return { config, model: createDockShellModel(pages, items[0]?.id ?? "") };
};

export default buildMinimalRailShell;
